const RegionAdminIconSubcategory = () => {
  return (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_2168_41042)" />
      <path
        d="M35.1543 19.0032C33.9827 19.1203 32.811 19.1789 31.698 19.4718C22.2662 21.9323 18.1654 33.1215 24.4337 40.6787C27.2457 44.0764 30.5263 47.0641 33.6312 50.2276C34.6857 51.3407 35.623 51.2235 36.7946 50.0518C39.3723 47.5328 41.9499 45.0138 44.4104 42.3775C46.8122 39.9171 48.2182 36.9294 48.5111 33.473C49.2141 26.033 42.9458 18.8274 35.1543 19.0032ZM35.0372 35.7577C32.8696 35.7577 31.1707 34.0003 31.1707 31.8913C31.1707 29.7237 32.9282 28.0248 35.0372 28.0248C37.2047 28.0248 38.9036 29.7823 38.9036 31.8913C38.9036 34.0588 37.2047 35.7577 35.0372 35.7577Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2168_41042"
          x1="-1.56654e-06"
          y1="4.96155"
          x2="70"
          y2="66.9615"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#CC4C21" />
          <stop offset="1" stop-color="#902400" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default RegionAdminIconSubcategory
